module.exports = __webpack_public_path__ + "img/google_login.146f1230.png";